import { Link } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function PaymentCancel() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="payment-cancel">
        <div className="bg-white border border-slate-200 rounded-3xl card-shadow p-10 max-w-md w-full text-center">
          <XCircle className="text-slate-400 mx-auto" size={44} />
          <h1 className="font-heading text-2xl font-bold text-slate-900 mt-5">Checkout cancelled</h1>
          <p className="text-slate-500 mt-2">No charge was made. You can pick a plan whenever you're ready.</p>
          <Link to="/ai-chatbot#pricing" data-testid="cancel-back-link" className="mt-7 inline-flex items-center gap-2 bg-brand text-white font-semibold rounded-xl px-6 py-3.5 hover:-translate-y-0.5 transition-transform">
            <ArrowLeft size={17} /> Back to pricing
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}
